<script>
import { Line, mixins} from 'vue-chartjs'


  export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props:['chartData'],
    watch:{
      chartData(){
        this.$data._chart.update();
      }
    },
    mounted() {
      let total = [this.chartData.total.first,this.chartData.total.second,this.chartData.total.third,this.chartData.total.fourth];
      let accepted = [this.chartData.accepted.first,this.chartData.accepted.second,this.chartData.accepted.third,this.chartData.accepted.fourth];
      let pending = [this.chartData.pending.first,this.chartData.pending.second,this.chartData.pending.third,this.chartData.pending.fourth];
      let rejected = [this.chartData.rejected.first,this.chartData.rejected.second,this.chartData.rejected.third,this.chartData.rejected.fourth];

      this.renderChart({
        labels: ['1er Trimestre', '2º Trimestre', '3er Trimestre', '4º Trimestre'],
        datasets: [
          {
            label: 'Total Presupuestos',
            backgroundColor: '#26c5da55',
            data: total
          },
          {
            label: 'Presupuestos Aceptados',
            backgroundColor: '#00ff00aa',
            data: accepted
          },
          {
            label:  'Presupuestos Rechazados',
            backgroundColor: '#ff000060',
            data: rejected
          },
          {
            label: 'Presupuestos Pendientes',
            backgroundColor: '#ffbb33cc',
            data: pending
          }
        ]
      },{responsive: true,maintainAspectRatio: false,
        cutoutPercentage: 50,})
    }
  }

</script>

<style scoped>
strong {
  font-weight: 600;
}

.random {
  width: 100%;
}

.random .vtc {
  height: 250px;
  font-size: 12px;
}

@media (min-width: 699px) {
  .random .vtc {
    height: 320px;
  }
}

.random .labels {
  stroke: rgba(0, 0, 0, 0.05);
}

.random .active-line {
  stroke: rgba(0, 0, 0, 0.2);
}

.random .point {
  stroke-width: 2;
  transition: stroke-width 0.2s;
}

.random .point.is-active {
  stroke-width: 5;
}

.random .curve1 .stroke {
  stroke: #fbac91;
  stroke-width: 2;
}

.random .curve1 .fill {
  fill: #fbac91;
  opacity: 0.05;
}

.random .curve1 .point {
  fill: #fbac91;
  stroke: #fbac91;
}

.random .curve2 .stroke {
  stroke: #fbe1b6;
  stroke-width: 2;
}

.random .curve2 .point {
  fill: #fbe1b6;
  stroke: #fbe1b6;
}

.random .curve3 .stroke {
  stroke: #7fdfd4;
  stroke-width: 2;
}

.random .curve3 .point {
  fill: #7fdfd4;
  stroke: #7fdfd4;
}

.random .tooltip {
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

.random .tooltip:not(.is-active) {
  display: none;
}

.random .tooltip-data {
  display: flex;
}

.random .tooltip-data-item {
  display: flex;
  align-items: center;
}

.random .tooltip-data-item:not(:first-child) {
  margin-left: 20px;
}

.random .tooltip-data-item:before {
  content: "";
  display: block;
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.random .tooltip-data-item--1:before {
  background: #fbac91;
}

.random .tooltip-data-item--2:before {
  background: #fbe1b6;
}

.random .tooltip-data-item--3:before {
  background: #7fdfd4;
}
</style>